/**
 * Keeps the per-tee prices in <bundle-discount-table> in sync with the selected variant.
 * The theme re-renders the product section on variant change and passes the new document in
 * `variant:update`, so we copy the freshly rendered rows instead of recalculating prices in JS.
 */
class BundleDiscountTable extends HTMLElement {
  connectedCallback() {
    this.section = this.closest('.shopify-section, dialog');
    this.section?.addEventListener('variant:update', this.update);
  }

  disconnectedCallback() {
    this.section?.removeEventListener('variant:update', this.update);
  }

  update = (event) => {
    const html = event.detail?.data?.html;
    const blockId = this.dataset.blockId;
    if (!html || !blockId) return;

    const next = html.querySelector(`bundle-discount-table[data-block-id="${blockId}"]`);
    if (!next) return;

    const currentParts = this.querySelectorAll('[data-bdt-dynamic]');
    const nextParts = next.querySelectorAll('[data-bdt-dynamic]');
    currentParts.forEach((part, i) => {
      const fresh = nextParts[i];
      if (fresh && part.innerHTML !== fresh.innerHTML) part.innerHTML = fresh.innerHTML;
    });
  };
}

if (!customElements.get('bundle-discount-table')) {
  customElements.define('bundle-discount-table', BundleDiscountTable);
}
